import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Conversion de la moyenne cumulative au système canadien";
const DESCRIPTION =
  "Conversion de la moyenne cumulative au système canadien pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "conversion de la moyenne cumulative au système canadien, calculatrice conversion de la moyenne cumulative au système canadien, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gradetocanada";
function GradeToCanada() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToCanadianGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "A+";
    } else if (gpa >= 3.7 && gpa < 4.0) {
      return "A";
    } else if (gpa >= 3.3 && gpa < 3.7) {
      return "A-";
    } else if (gpa >= 3.0 && gpa < 3.3) {
      return "B+";
    } else if (gpa >= 2.7 && gpa < 3.0) {
      return "B";
    } else if (gpa >= 2.3 && gpa < 2.7) {
      return "B-";
    } else if (gpa >= 2.0 && gpa < 2.3) {
      return "C+";
    } else if (gpa >= 1.7 && gpa < 2.0) {
      return "C";
    } else if (gpa >= 1.3 && gpa < 1.7) {
      return "C-";
    } else if (gpa >= 1.0 && gpa < 1.3) {
      return "D+";
    } else if (gpa >= 0.7 && gpa < 1.0) {
      return "D";
    } else if (gpa >= 0.0 && gpa < 0.7) {
      return "F";
    } else {
      return "Entrée invalide";
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 5).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToCanadianGrade(gpa);
      }
    }
    return "Entrée invalide";
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Découvrez comment convertir votre moyenne universitaire (en pourcentage ou cumulatif) au système canadien 
                  facilement et précisément. Connaître les détails du système canadien des notes universitaires avec cet outil utile.
                </p>
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Conversion au système canadien
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>Type de note:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      Pourcentage (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gpaConversion"
                      className="form-check-label"
                    >
                      GPA (4)
                    </label>
                  </div>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="originalGrade">
                      {conversionType === "grade" ? "Pourcentage: " : "GPA: "}
                    </label>
                  </b>
                  <input
                    type="text"
                    value={originalValue}
                    id="originalGrade"
                    onChange={(e) => setOriginalValue(e.target.value)}
                    className="form-control"
                    style={{ width: "200px", marginRight: "10px" }}
                  />
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Calculer
                </button>
                <br />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <br />
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Erreur:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&   (
                  <div
                    style={{ fontSize: "17px" }}
                    className=" bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Résultats:</strong>
                    </div>
                    <b>Équivalent canadien: {convertedValue}</b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default GradeToCanada;
